import {
    typeClinicalAnalysis,
    typeMedicine,
    typeMedicineInfusion,
    typeSelfService,
    typeService,
    typeVaccine,
    typeVaccineCombo
} from "../../assets";

/**
 * PEC-368 — project-wide map from the card icon code emitted by the API
 * (product.icon, from the category_service_type source model) to its asset.
 *
 * Mirrors the backend AttributeSetProfile. Adding a future attribute set =
 * one entry here (plus the backend profile). Consumed by the product cards,
 * the header search item and the category tree, so it stays in utils/.
 */
export const serviceTypeIconEnum = {
    clinical_analysis: typeClinicalAnalysis,
    vaccine_combo: typeVaccineCombo,
    vaccine: typeVaccine,
    self_service: typeSelfService,
    infusao_medicamentos: typeMedicineInfusion,
    medicamentos: typeMedicine,
    servicos: typeService
};
